"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeliveryAddresses = void 0;
const module_cart_b2ag_interfaces_1 = require("@invivodf/module-cart-b2ag-interfaces");
const getDeliveryAddresses = (getHomeDeliveryAddresses, getPickupPointDeliveryAddresses, searchClickAndCollectAddresses) => async ({ checkoutId, consignmentId, logisticRoute }) => {
    switch (logisticRoute) {
        case module_cart_b2ag_interfaces_1.LogisticRoute.HomeDelivery:
            return getHomeDeliveryAddresses({
                checkoutId,
                consignmentId
            });
        case module_cart_b2ag_interfaces_1.LogisticRoute.PickupPoint:
            return getPickupPointDeliveryAddresses({
                checkoutId,
                consignmentId
            });
        case module_cart_b2ag_interfaces_1.LogisticRoute.ClickAndCollect:
            return searchClickAndCollectAddresses({
                checkoutId,
                consignmentId
            });
        default:
            throw new Error(`Unsupported logistic route: ${logisticRoute}`);
    }
};
exports.getDeliveryAddresses = getDeliveryAddresses;
